export enum NewsCreatorRoles {
  UPP_PRESIDENT = "UPP_PRESIDENT",
  ADMINISTRATOR = "ADMINISTRATOR",
  LABORATORY_CONTACT = "LABORATORY_CONTACT",
  UPP_REPRESENTATIVE = "UPP_REPRESENTATIVE",
}
